const PAYMENTS_WIDGET = 'payments-queue';
const RETIRED_PAYMENT_WIDGETS = new Set(['payments-detail', 'payments-comms']);

// Retain the existing queue's position and geometry. A detail/comms-only saved
// board keeps one payment entry in its original position rather than losing the
// workflow altogether. A deliberately removed payment widget stays removed.
export function migrateCasePaymentLayout(layout) {
  if (!Array.isArray(layout)) return [];
  const entries = layout.filter(entry => entry && typeof entry === 'object' && typeof entry.id === 'string');
  const hasQueue = entries.some(entry => entry.id === PAYMENTS_WIDGET);
  const seen = new Set();
  return entries.reduce((result, entry) => {
    const retired = RETIRED_PAYMENT_WIDGETS.has(entry.id);
    if (retired && hasQueue) return result;
    const id = retired ? PAYMENTS_WIDGET : entry.id;
    if (seen.has(id)) return result;
    seen.add(id);
    result.push({ ...entry, id });
    return result;
  }, []);
}
